export const PUBLICATION_SEND_MENU_CONSTS = {
  menu1: 'В главное за день',
  menu2: 'В социальные сети',
  menu3: 'В push-уведовления',
  sendMsg: 'Отправить'
}
